import { render, staticRenderFns } from "./UpdateSingleDocument.vue?vue&type=template&id=df632de0&scoped=true"
import script from "./UpdateSingleDocument.vue?vue&type=script&lang=js"
export * from "./UpdateSingleDocument.vue?vue&type=script&lang=js"
import style0 from "./UpdateSingleDocument.vue?vue&type=style&index=0&id=df632de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df632de0",
  null
  
)

export default component.exports